export default "__VITE_ASSET__B$ZNXyk6__"